import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";

interface IProps {
    reload: boolean;
    toast: any
}

export interface IMassMailServerSetting {
    id?: number,
    server_Name?: string,
    server_Email?: string,
    server_Password?: string,
    server_Port?: number,
    server_Max_Limit?: number,
    server_Limit_Used?: number,
    server_Status?: boolean,
    server_InUse_Status?: boolean,
    updated_By?: string,
    updated_At?: Date,
}

export const MassMailServerSettingTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false, } as { tableData: Array<IMassMailServerSetting>; loading: boolean });
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("MassMail/getMassMailServerSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMassMailServerSetting> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", }}
                size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found."
                loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="server_Name" header="Server Name" />
                <Column field="server_Email" header="Server Email" />
                <Column field="server_Password" header="Server Password" />
                <Column field="server_Port" header="Server Port" />
                <Column field="server_Max_Limit" header="Server Per Day Max Limit" />
                <Column field="server_Limit_Used" header="Server Todays Limit Is Used" />
                <Column field="server_Status" header="Server Status" body={(rowData: IMassMailServerSetting) => <p style={{ color: (rowData.server_Status === true ? "green" : "red") }}>{rowData.server_Status === true ? "Active" : "InActive"}</p>} />
                <Column field="server_InUse_Status" header="Server In Use Status" body={(rowData: IMassMailServerSetting) => <p style={{ color: (rowData.server_Status === true ? "green" : "red") }}>{rowData.server_Status === true ? "Yes" : "No"}</p>} />
                <Column field="updated_By" header="updated By" />
            </DataTable>
        </>
    );
}